import helpers from "./helpers";

const SET_VISIBLE = (state) => state.visible = true;

const SET_HIDDEN = (state) => state.visible = false;

const SET_MODE = (state, mode) => state.mode = mode;

const SET_Q = (state, q) => state.q = q;

const SET_QUERY_FILTER = (state, payload) => state.queryFilters = payload;

const SET_AUTOCOMPLETE = (state, {sts, products, correction}) => {
    state.autocomplete.sts = sts; // часто ищут
    state.products = products;
    state.autocomplete.correction = correction;
};

const SET_TIPS = (state, {sts, query}) => {
    const tips = sts.map(item => {
        const a = item.st.split(' ');
        const words = a.filter(b => {
            return b.length > 1;
        })

        if((words[0].toString().toLowerCase() === query.toString().toLowerCase()) && words.length > 1) {
            return words[1].toLowerCase()
        }
    })
    const unique = (value, index, self) => {
        return self.indexOf(value) === index
    }

    const ret = tips.filter(unique);
    state.tips = (typeof ret[0] !== 'undefined') ? ret : [];
}

const SET_AUTOCOMPLETE_CATEGORIES = (state, {categories}) => {
    state.autocomplete.categories = categories;
}

const CLEAR_TIPS = (state) => state.tips = [];

const SET_SEARCH = (state, {totalHits, products}) => {
    state.totalHits = totalHits;
    state.products = products;
};

const ADD_TO_SEARCH = (state, {products}) => {
    state.products = [...state.products, ...products];
};

const SET_FACETS = (state, {facets, stf, selected_category}) => {

    const exclude_names = [
        'categories',
        'brands',
        'Код цвета',
        'Цвет',
        'Новинка',
        'Наличие',
        'DISTINCT',
        'price'
    ];
    let tags = facets.filter((item) => {
        return (!exclude_names.includes(item.name));
    });
    // сортировка массива объектов тегов
    tags.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1: 0));
    tags = tags.map(function (item) {
        item.values.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1: 0))
        return item;
    });

    let state_facets = state[stf]

    state_facets.tags = tags;

    // brands
    state_facets.brands = helpers.filterFacets(facets, 'brands');
    // colors
    state_facets.colors = helpers.filterFacets(facets, 'Код цвета');
    // novelty
    state_facets.novelty = helpers.filterFacets(facets, 'Новинка');
    // hit
    state_facets.hit = helpers.filterFacets(facets, 'Хит');
    // availability
    state_facets.availability = helpers.filterFacets(facets, 'Наличие');
    // categories
    if(typeof selected_category === 'undefined' || selected_category == 0) {
        state_facets.categories = helpers.filterFacets(facets, 'categories');
    }
};


const SET_PRICES = (state, {facets, stf}) => {
    let state_facets = state[stf]

    state_facets.prices = helpers.filterFacets(facets, 'price');
    state.priceRange.min = state_facets.prices[1].value;
    state.priceRange.max = state_facets.prices[0].value;
    //console.log('min', state_facets.prices[1].value)
    //console.log('max', state_facets.prices[0].value)
}

// выбранные фасеты (с галочкой)
const SET_SELECTED_FACETS = (state, {selectedFacets}) => {

    let ret = [];
    for(let facet in selectedFacets) {
        const name = selectedFacets[facet]['name'];

        /*let mb = selectedFacets[facet]['values'].map(function (item) {
            return item.name;
        });*/

        if(name === 'price') {
            //@todo in selected price
            continue;
        }

        if(name === 'categories') {
            //console.log('selectedFacets', selectedFacets[facet]['values'][0])
            state.selected_category_name = selectedFacets[facet]['values'][0].name;
        }

        const values = selectedFacets[facet]['values'].map(function (item) {
            return item.name;
        });

        ret.push({name: name, value: values});

    }
    state.facets.selected = ret;
};

const SET_HISTORY = (state, history) => state.history = history;
const SET_SELECTED_CATEGORY = (state, payload) => {
    state.selected_category = parseInt(payload);
    state.selected_category_name = '';
}
const SET_MOBILE = (state, payload) => state.isMobile = payload;
const SET_IE = (state, payload) => state.isIE = payload;
const SET_SORT = (state, payload) => state.sort = payload;
const SET_SHOW_SORT_MOBILE = (state, payload) => state.showSortMobile = payload;
const SET_PAGINATION = (state, payload) => {};
const SET_CURRENT_PAGE = (state, payload) => state.currentPage = payload;

const SET_PRICE_SELECTED = (state, payload) => {
    state.priceSelected[0] = payload.min;
    state.priceSelected[1] = payload.max;
};

const SET_DO_SEARCH_ADD_MODE = (state, payload) => state.doSearchAddMode = payload;

const SET_SEARCH_PARAM = (state, payload) => state.searchParam = payload;
const SET_HEADER_SELECTOR = (state, payload) => state.headerSelector = payload;
const SET_API_KEY = (state, payload) => state.apiKey = payload;
const SET_BASE_URL = (state, payload) => state.baseUrl = payload;
const SET_SELECTED_PARAM = (state, payload) => state.selected_param = payload;

const SET_CURRENT_OPEN_FACET = (state, payload) => state.currentOpenFacet = payload;
const SET_IS_WAS_SEARCH = (state, payload) => state.isWasSearch = payload;
const SET_REDIRECT = (state, payload) => state.redirectUrl = payload;

// Доп функционал фильтра товаров категории
const SET_CATEGORY_FILTER = (state, payload) => state.isCategoryFilter = payload;

export default {
    SET_VISIBLE,
    SET_HIDDEN,
    SET_MODE,
    SET_Q,
    SET_QUERY_FILTER,
    SET_AUTOCOMPLETE,
    SET_TIPS,
    SET_AUTOCOMPLETE_CATEGORIES,
    CLEAR_TIPS,
    SET_SEARCH,
    ADD_TO_SEARCH,
    SET_FACETS,
    SET_SELECTED_FACETS,
    SET_HISTORY,
    SET_SELECTED_CATEGORY,
    SET_MOBILE,
    SET_IE,
    SET_SORT,
    SET_SHOW_SORT_MOBILE,
    SET_PAGINATION,
    SET_CURRENT_PAGE,
    SET_PRICE_SELECTED,
    SET_DO_SEARCH_ADD_MODE,
    SET_SEARCH_PARAM,
    SET_HEADER_SELECTOR,
    SET_API_KEY,
    SET_BASE_URL,
    SET_SELECTED_PARAM,
    SET_PRICES,
    SET_CURRENT_OPEN_FACET,
    SET_IS_WAS_SEARCH,
    SET_REDIRECT,
    SET_CATEGORY_FILTER
};